import {ISyncField, TBaseOrObservableOrFunctionType, TBaseOrObservableType} from "../../index";
import {ObjectTypeId} from "../../constants";
import {Editor} from "tinymce";
import {IDialogOptionsComponent} from "../dialog/index";

export interface IAbstractInputParams {
    attr?: any
    disable?: TBaseOrObservableOrFunctionType<boolean>
    dynamicSupport?: boolean
    editor?: KnockoutObservable<Editor>
    enable?: TBaseOrObservableOrFunctionType<boolean>
    event?: any // this object is passed to the event-binding
    expression: KnockoutObservable<string>
    objectTypeId: TBaseOrObservableType<ObjectTypeId>
    objectTypeIds: ObjectTypeId[] | KnockoutObservableArray<ObjectTypeId> | KnockoutComputed<ObjectTypeId[]>
    placeholder?: string
    rows?: number
    sort?: TSort
    type?: string
}

interface IDynamicVariableTextInputParams extends IAbstractInputParams {
    canOpenInDialog?: boolean
}

interface IBoundsAndRange {
    selectionRange: Range
    textRange: ITextRange
    textBounds: ClientRect
}

// this can be converted to an IDOMBox
interface IRect {
    bottom: number
    height: number
    left: number
    right: number
    top: number
    width: number
}

// this can be assigned to a css binding
interface IRectCss {
    bottom: string | null
    height: string | null
    left: string | null
    right: string | null
    top: string | null
    width: string | null
}

interface ITextRange {
    caret: number
    end: number
    start: number
    str: string
    wrapperEnd: number
    wrapperStart: number
    wrapperStr: string
}

type TSort = 'alphabetically' | 'type';

interface ISyncfieldParameterDialog {
    attribute: string
    parameterDialog: IDialogOptionsComponent
    syncfieldid: number
}

interface ISyncfieldParameterObject {
    css: "selected" | null
    dialog?: IDialogOptionsComponent | undefined
    index: number
    object?: ISyncfieldParameterDialog | undefined
    selected: boolean
    syncfield: ISyncField
    text?: string | undefined
}
